import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Give Us a Shout`}</h1>
    <p>{`Feel free to contact us to learn more and discuss your specific needs. We can be reached at `}<a parentName="p" {...{
        "href": "mailto:support@openarchitex.dev"
      }}>{`support@openarchitex.dev`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      